// Copyright (c) 2019 Deere & Company

export const PartGroupFiveTableColumnDefinitions = [
    {
        field: 'productSeriesName',
        headerName: 'Product Series',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,
    },
    {
        field: 'functionCodeName',
        headerName: 'Function Code',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,
    },
    {
        field: 'partNumber',
        headerName: 'Part Number',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,
    },
    {
        field: 'manufacturingModule',
        headerName: 'Manufacturing Module',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,
    },
    {
        field: 'designTeamCode',
        headerName: 'Design Module',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,
    },
];
